import { z } from 'zod';
import { ChatResponseType } from '../../enums';
import type { Chat } from '../../types';

export declare namespace UpdateQueryRating {
  export type Request = {
    chatInstanceId: number;
    queryIdentifier: string;
    rating: number;
  };

  export type Response = {
    query: Chat.Query<ChatResponseType, string>;
  };
}

export declare namespace UpdateQueryFeedback {
  export type Request = {
    chatInstanceId: number;
    queryIdentifier: string;
    feedback: Chat.QueryFeedback;
  };

  export type Response = {
    query: Chat.Query<ChatResponseType, string>;
  };
}

export declare namespace GetQueryFeedback {
  export type Request = {
    chatInstanceId: number;
    queryIdentifier: string;
  };

  export type Response = {
    feedback: Chat.QueryFeedback;
  };
}

export declare namespace GetQuery {
  export type Request = {
    chatInstanceId: number;
    queryIdentifier: string;
  };

  export type Response = {
    chatInstance: Chat.Instance<string>;
    query: Chat.Query<ChatResponseType, string>;
  };
}

export declare namespace DownloadQueryTable {
  export type Request = {
    chatInstanceId: number;
    queryIdentifier: string;
  };

  export type Response = Buffer;
}

export declare namespace CancelQueryHcpSelection {
  export type Request = {
    chatInstanceId: number;
    queryIdentifier: string;
  };

  export type Response = void;
}

export declare namespace DownloadHcpResults {
  export type Request = {
    brandIdentifier: string;
    chatInstanceId: number;
    queryIdentifier: string;
  };

  export type Response = Buffer;
}

export declare namespace GetQueryResponseText {
  export type Request = {
    chatInstanceId: number;
    queryId: number;
    tts: boolean;
  };

  export type Response = {
    value: string;
  };
}

export declare namespace DownloadQueryResponse {
  export type Request = {
    chatId: number;
    queryIdentifier: string;
  };
}

export namespace CancelQuery {
  export const cancelQueryParamsSchema = z.object({
    chatId: z.coerce.number(),
    queryIdentifier: z.string(),
  });

  export type Request = z.infer<typeof cancelQueryParamsSchema>;
}


export declare namespace UpdateQuerySmartRouting {
  export type Request = {
    chatInstanceId: number;
    queryIdentifier: string;
    smartRoutingState: Chat.QueryState.SmartRouting;
  };

  export type Response = {
    smartRoutingState: Chat.QueryState.SmartRouting;
  };
}